import FitnessTwo from "../../assets/images/webp/newStartHerePage/fitnessTwo.webp";
import FitnessThree from "../../assets/images/webp/newStartHerePage/fitnessThree.webp";
import FitnessFour from "../../assets/images/webp/newStartHerePage/fitnessFour.webp";
import FitnessFive from "../../assets/images/webp/newStartHerePage/fitnessFive.webp";
import FitnessSix from "../../assets/images/webp/newStartHerePage/fitnessSix.webp";
import SlideImgOne from "../../assets/images/webp/overviewPage/phoneThreeUpdated.webp";
import SlideImgTwo from "../../assets/images/webp/overviewPage/slideImageTwo.webp";
import SlideImgThree from "../../assets/images/webp/overviewPage/phoneTwoUpdated.webp";
import SlideImgFour from "../../assets/images/png/slideImageFour.png";
import SlideImgFive from "../../assets/images/webp/overviewPage/slideImgFive.webp";
import SlideImgSix from "../../assets/images/webp/overviewPage/slideImageSix.webp";
import NbpNews from "../../assets/images/webp/overviewPage/nbpNews.webp";
import AbcNews from "../../assets/images/webp/overviewPage/abcNewsUpdated.webp";
import DigitalJournalNews from "../../assets/images/webp/overviewPage/digitalJournalNews.webp";
import FoxNews from "../../assets/images/webp/overviewPage/foxNews.webp";
import MarketWatchNews from "../../assets/images/webp/overviewPage/marketWatchNews.webp";
import UseTodayNews from "../../assets/images/webp/overviewPage/usaTodayNewsUpdated.webp";
import InstaOne from "../../assets/images/webp/clients/instaOne.webp";
import InstaTwo from "../../assets/images/webp/clients/instaTwo.webp";
import InstaThree from "../../assets/images/webp/clients/instaThree.webp";
import InstaFour from "../../assets/images/webp/clients/instaFour.webp";
import InstaFive from "../../assets/images/webp/clients/instaFive.webp";
import InstaSix from "../../assets/images/webp/clients/instaSix.webp";
import InstaSeven from "../../assets/images/webp/clients/instaSeven.webp";
import InstaEight from "../../assets/images/webp/clients/instaEight.webp";
import InstaNine from "../../assets/images/webp/clients/instaNine.webp";
import InstaTen from "../../assets/images/webp/clients/instaTen.webp";
import InstaEleven from "../../assets/images/webp/clients/instaEleven.webp";
import InstaTwelve from "../../assets/images/webp/clients/instaTwelve.webp";
import InstaThirteen from "../../assets/images/webp/clients/instaThirteen.webp";
import InstaFourteen from "../../assets/images/webp/clients/instaFourteen.webp";
import InstaFifteen from "../../assets/images/webp/clients/instaFifteen.webp";
import InstaSixteen from "../../assets/images/webp/clients/instaSixteen.webp";
import InstaSeventeen from "../../assets/images/webp/clients/instaSeventeen.webp";
import PhoneOne from "../../assets/images/webp/overviewPage/phoneOneUpdate.webp";
import PhoneTwo from "../../assets/images/webp/overviewPage/phoneTwoUpdated.webp";
import PhoneThree from "../../assets/images/webp/overviewPage/phoneThreeUpdated.webp";
import PhoneFour from "../../assets/images/webp/overviewPage/phoneFourUpdated.webp";
import PhoneFive from "../../assets/images/webp/overviewPage/phoneFiveUpdated.webp";
import MemberOne from "../../assets/images/webp/overviewPage/memberOne.webp";
import MemberTwo from "../../assets/images/webp/overviewPage/memberTwo.webp";
import MemberThree from "../../assets/images/webp/overviewPage/memberThree.webp";
import MemberFour from "../../assets/images/webp/overviewPage/memberFour.webp";
import MemberFive from "../../assets/images/webp/overviewPage/memberFive.webp";
import MemberSix from "../../assets/images/webp/overviewPage/memberSix.webp";
import MemberSeven from "../../assets/images/webp/overviewPage/memberSeven.webp";
import MemberEight from "../../assets/images/webp/overviewPage/memberEight.webp";
import InpersonLargeImg from "../../assets/images/jpeg/inpersonWorkout.jpg";
import VirtualLargeImg from "../../assets/images/jpeg/virtualWorkout.jpg";
import InPersonBlockImg from "../../assets/images/jpeg/inPersonProgramImg.jpg";
import OnlineBlockImg from "../../assets/images/jpeg/onlineWorkout.jpg";
import VirtualBlockImg from "../../assets/images/jpeg/virtualWorkoutImg.jpg";
import MemberNithanial from "../../assets/images/jpeg/NithanialDecker.jpg";
import MemberDaniel from "../../assets/images/jpeg/DanielBun.jpg";
import MemberAmy from "../../assets/images/jpeg/AmyPerkins.jpg";
import MemberMary from "../../assets/images/jpeg/MaryBurovacUpdated.jpeg";
import MemberJosh from "../../assets/images/jpeg/JoshEdie.jpg";
import MemberSteve from "../../assets/images/jpeg/SteveMagic.jpg";
import MemberNicole from "../../assets/images/jpeg/NicoleDuke.jpg";
import MemberDustin from "../../assets/images/jpeg/DustinQuarles.jpg";

const CONSTANTS = {
  baseUrl: "https://myaccount.omniactivefitness.com/",
  freshlyUrl: "https://getfresh.ly/omniactive125",
  shopUrl: "https://www.gearbyfuzion.com/omni-active-fitness-client/shop/home",
  homepageVideo: "https://drive.google.com/uc?id=1f5WWr89A3eeV8og9Yor_i8ZzEiACCVKh",
  /** different button types that determine the apperance of the button */

  SAVE_TYPE: "save",
  ROUNDED_TYPE: "rounded",
  GREY_TYPE: "grey",
  WHITE_TYPE: "white",

  // for download section of start new page

  mobileOne: SlideImgTwo,
  mobileTwo: PhoneTwo,
  mobileThree: PhoneThree,
  // nav items

  NAV_ITEMS: [
    {
      label: "Overview",
      pathName: "/",
    },
    {
      label: "New? Start Here",
      pathName: "/newStartHere",
    },
    {
      label: "Programs",
      pathName: "/programs",
    },
    {
      label: "Clients",
      pathName: "/clients",
    },
    {
      label: "Shop",
      url: "https://www.gearbyfuzion.com/omni-active-fitness-client/shop/home",
    },
    {
      label: "Updates",
      pathName: "/updates",
    },
    {
      label: "Careers",
      pathName: "/careers",
    },
    {
      label: "Contact",
      pathName: "/contact",
    },
  ],

  // Phone images for online workout section

  phoneOne: PhoneOne,
  phoneTwo: PhoneTwo,
  phoneThree: PhoneThree,
  phoneFour: PhoneFour,
  phoneFive: PhoneFive,

  // for workout group images

  inPersonLargeImage: InpersonLargeImg,
  VirtualLargeImage: VirtualLargeImg,
  //mailchimp variables
  success: "success",
  error: "error",

  // sliding images width and animations
  fixedWidth: "fix-width",
  smallFixedWidth: "small-fixed-width",
  newsFixedWidth: "news-fixed-width",
  instaWidth: "insta-fixed-width",

  newsAnimation: "newsAnimation",
  inPersonAnimation: "inPersonAnimation",
  virtualAnimation: "virtualAnimation",
  instagramAnimation: "instagramAnimation",
  careersBannerAnimation: "careersBannerAnimation",

  /** icon styles to be assigned to react icons  */
  ICON_STYLES: { cursor: "pointer", fontSize: "1.8rem" },
  BIG_ICON: { fontSize: "2.5rem", cursor: "pointer" },
  SMALL_ICON: { cursor: "pointer", fontSize: "1.2rem" },
  EXTRA_BIG_ICON: { fontSize: "4rem", cursor: "pointer" },

  moreInformationData: [
    {
      title: "What is the Omni-Active® App?",
      Description:
        "Our app is our hub for our clients and trainers alike. Using our app, you can message your trainer, answer daily trivia questions, sign in for training sessions, calculate your macros, earn badges, track your activity, and follow along with workouts built for you by your trainer.",
    },
    {
      title: "Do I need my own equipment?",
      Description:
        "Nope! We can design workouts around what you have. Whether that’s just bodyweight exercises or a fully equipped gym, we can accommodate everyone. If you’re meeting us in-person, we can even bring our equipment to you!",
    },
    {
      title: "Does Omni-Active® have workouts for different levels of fitness?",
      Description:
        "Absolutely! Our team of elite fitness professionals will build workouts for you, designed to meet you where you’re at and take you where you want to go!",
    },
    {
      title: "Do I have to have a fitness tracking watch to use the app? ",
      Description:
        "No. Our app functions just as well on it’s own. With a tracking device, you’re able to see your tracked activity all in one place, but it’s not necessary for the app to function.",
    },
    {
      title: "Do I need to have prior workout exerpience? ",
      Description:
        "No! We will meet you where you’re at in terms of experience, building with each workout towards a new you.",
    },
    {
      title: "How do I connect my watch to the experience? ",
      Description:
        "Using the menu at the bottom of your home screen in the app, click on activity. From there, follow the prompts to allow the app access to your apple health kit app or google fit.",
    },
    {
      title: "Can I sign up my company for this?",
      Description:
        "Absolutely! We have wellness programs that can be customized based on the size of the company. Please reach out to info@omniactive.com for more details.",
    },
  ],

  teamImages: [
    { id: 1, img: MemberOne, name: "Nithanial Decker" },
    { id: 2, img: MemberTwo, name: "Amy Perkins" },
    { id: 3, img: MemberThree, name: "Daniel Bun" },
    { id: 4, img: MemberFour, name: "Nicole Duke" },
    { id: 5, img: MemberFive, name: "Dustin Quarles" },
    { id: 6, img: MemberSix, name: "Steve Magic" },
    { id: 7, img: MemberSeven, name: "Josh Edie" },
  ],

  teamImagesOne: [
    { id: 1, img: MemberNithanial, name: "Nithanial Decker" },
    { id: 2, img: MemberAmy, name: "Amy Perkins" },
    { id: 3, img: MemberDaniel, name: "Daniel Bun" },
    { id: 4, img: MemberMary, name: "Mary Burovac" },
    { id: 5, img: MemberNithanial, name: "Nithanial Decker" },
    { id: 6, img: MemberAmy, name: "Amy Perkins" },
    { id: 7, img: MemberDaniel, name: "Daniel Bun" },
    { id: 8, img: MemberMary, name: "Mary Burovac" },
    { id: 9, img: MemberNithanial, name: "Nithanial Decker" },
    { id: 10, img: MemberAmy, name: "Amy Perkins" },
    { id: 11, img: MemberDaniel, name: "Daniel Bun" },
    { id: 12, img: MemberMary, name: "Mary Burovac" },
    { id: 13, img: MemberNithanial, name: "Nithanial Decker" },
    { id: 14, img: MemberAmy, name: "Amy Perkins" },
    { id: 15, img: MemberDaniel, name: "Daniel Bun" },
    { id: 16, img: MemberMary, name: "Mary Burovac" },
  ],

  teamImagesTwo: [
    { id: 1, img: MemberNicole, name: "Nicole Duke" },
    { id: 2, img: MemberDustin, name: "Dustin Quarles" },
    { id: 3, img: MemberSteve, name: "Steve Magic" },
    { id: 4, img: MemberJosh, name: "Josh Edie" },
    { id: 5, img: MemberNicole, name: "Nicole Duke" },
    { id: 6, img: MemberDustin, name: "Dustin Quarles" },
    { id: 7, img: MemberSteve, name: "Steve Magic" },
    { id: 8, img: MemberJosh, name: "Josh Edie" },
    { id: 9, img: MemberNicole, name: "Nicole Duke" },
    { id: 10, img: MemberDustin, name: "Dustin Quarles" },
    { id: 11, img: MemberSteve, name: "Steve Magic" },
    { id: 12, img: MemberJosh, name: "Josh Edie" },
    { id: 13, img: MemberNicole, name: "Nicole Duke" },
    { id: 14, img: MemberDustin, name: "Dustin Quarles" },
    { id: 15, img: MemberSteve, name: "Steve Magic" },
    { id: 16, img: MemberJosh, name: "Josh Edie" },
  ],

  virtualTestimonials: [
    {
      feedback:
        "Taking our workouts virtual has allowed me to stay on track when I'm out of town on business. The convenience and value is much appreciated",
      clientName: "Jim B",
    },
    {
      feedback:
        "Virtual sessions with my trainer put me at ease when either of us aren't feeling 100%. In times like these, the virtual option has been a great offering that allows me peace of mind that I can reach my fitness goals without risking my health.",
      clientName: "Diane H.",
    },
    {
      feedback:
        "I train in-person with my trainer, but when either of us is out of town or if I'm stuck at the office, virtual sessions allow me to workout when my schedule otherwise won't allow it.",
      clientName: "Jeff A",
    },
    {
      feedback:
        "I was apprehensive at first that virtual sessions would give me everything that I was looking for from a trainer. I've been delighted with both the experience and my results so far!",
      clientName: "Mary P",
    },
    {
      feedback:
        "The ease of working out at home with my trainer has been a game changer, as I turned 40 this past year. But with the craziness of kids, work, Covid quarantining, life, etc, my trainer has been flexible and easily pivoted to virtual workouts when necessary so that we never slowed down our progress. I was surprised at how seamless working out virtually is. My trainers virtual workouts are just as challenging, he corrects my form exactly the same despite seeing me on a screen, and ultimately I can remain just as accountable for my health. He also makes me laugh as much virtually as he does in person, which may just be his way of making my planking harder.",
      clientName: "Jamie B",
    },
  ],

  inPersonTestimonials: [
    {
      feedback:
        "The entire team go personal trainers are top notch. They push me to find my limits, while at the same time motivating me to best my goals. My trainer, Dustin, has been amazing. He is a beast. He is always encouraging me and motivating me to do my best. The work is difficult, but the results are worth it. The exercise, diet / meal plans, and motivation are paying off. I’m losing weight, feel good, and getting into shape. Thanks!",
      clientName: "SCOTT B.",
    },
    {
      feedback:
        "I’ve had a really positive experience! My personal trainer has motivated me to work hard and guided me on how to achieve my goals. I really appreciate the personal approach and the flexibility to work around my busy and erratic work schedule. I definitely would recommend them!",
      clientName: "	ERIC G.",
    },
    {
      feedback:
        "“I have been working with their personal trainers for 2 years and have found them to be friendly, encouraging, very knowledgeable and dedicated to helping me achieve my fitness goals. My current trainer, Josh, has helped me work through several sports related injuries and has been a fantastic resource for not only exercise and physical therapy but also for nutrition and the mental aspects of becoming and staying physically fit.",
      clientName: "CARLOS H.",
    },
    {
      feedback: "Love working out with my personal trainer, Mary! She is positive and supportive!",
      clientName: "HALLIE S.",
    },
  ],

  onlineTestimonials: [
    {
      feedback:
        "Omni-Active® can change your life. As a mother of 6 and a former college athlete, I thought my life was too busy to include strength training. Nithanial and the trainers at Omni-Active® make it easy and fun (albeit challenging) to squeeze high quality training sessions into a busy life. I’m proud to say I am an overall stronger, more well rounded athlete now than I was in college!",
      clientName: "ELLIE H.",
    },
    {
      feedback:
        "My husband and I just had our first consult with Nithanial at our home and we were extremely impressed. He was polite, professional and made us both feel 100% comfortable. We had absolutely no hesitation in signing up for training sessions after meeting with him in person. Looking forward to getting started :)",
      clientName: "SHANNON R.",
    },
  ],

  testimonialSlides: [
    {
      feedback:
        "Omni-Active® can change your life. As a mother of 6 and a former college athlete, I thought my life was too busy to include strength training. Nithanial and the trainers at Omni-Active® make it easy and fun (albeit challenging) to squeeze high quality training sessions into a busy life. I’m proud to say I am an overall stronger, more well rounded athlete now than I was in college!",
      clientName: "ELLIE H.",
    },
    {
      feedback:
        "The entire team go personal trainers are top notch. They push me to find my limits, while at the same time motivating me to best my goals. My trainer, Dustin, has been amazing. He is a beast. He is always encouraging me and motivating me to do my best. The work is difficult, but the results are worth it. The exercise, diet / meal plans, and motivation are paying off. I’m losing weight, feel good, and getting into shape. Thanks!",
      clientName: "SCOTT B.",
    },
    {
      feedback:
        "My husband and I just had our first consult with Nithanial at our home and we were extremely impressed. He was polite, professional and made us both feel 100% comfortable. We had absolutely no hesitation in signing up for training sessions after meeting with him in person. Looking forward to getting started :)",
      clientName: "SHANNON R.",
    },
    {
      feedback:
        "I’ve had a really positive experience! My personal trainer has motivated me to work hard and guided me on how to achieve my goals. I really appreciate the personal approach and the flexibility to work around my busy and erratic work schedule. I definitely would recommend them!",
      clientName: "	ERIC G.",
    },
    {
      feedback:
        "We have been using Omni-Active® for a year and have seen great results. Our trainer has been amazing and really pushes us to do the best we can so we get the most out of our workouts. What’s even better they personalize your workout to your goals and skill sets. We have found this to be the best way to get real results.",
      clientName: "KATHERINE M.",
    },
    {
      feedback:
        "“I have been working with their personal trainers for 2 years and have found them to be friendly, encouraging, very knowledgeable and dedicated to helping me achieve my fitness goals. My current trainer, Josh, has helped me work through several sports related injuries and has been a fantastic resource for not only exercise and physical therapy but also for nutrition and the mental aspects of becoming and staying physically fit.",
      clientName: "CARLOS H.",
    },
    {
      feedback: "Love working out with my personal trainer, Mary! She is positive and supportive!",
      clientName: "HALLIE S.",
    },
  ],
  muscleBuilding: "muscleBuilding",
  weightLoss: "weightLoss",
  generalFitness: "generalFitness",
  atheleticPerformance: "atheleticPerformance",

  //mailchimp access paramaters
  mailChimpPostUrl:
    "https://omniactivefitness.us4.list-manage.com/subscribe/post?u=047371c7d334d8dd205abe09b&amp;id=3c9c9dcff3",

  // sliding images width and animations
  fixedWidth: "fix-width",
  smallFixedWidth: "small-fixed-width",
  newsFixedWidth: "news-fixed-width",
  instaWidth: "insta-fixed-width",

  newsAnimation: "newsAnimation",
  inPersonAnimation: "inPersonAnimation",
  virtualAnimation: "virtualAnimation",
  instagramAnimation: "instagramAnimation",
  careersBannerAnimation: "careersBannerAnimation",

  galleryImages: [
    {
      id: 1,
      galleryImg: FitnessTwo,
    },
    {
      id: 2,
      galleryImg: FitnessThree,
    },
    {
      id: 3,
      galleryImg: FitnessFour,
    },
    {
      id: 4,
      galleryImg: FitnessFive,
    },
    {
      id: 5,
      galleryImg: FitnessSix,
    },
  ],
  instagramFeed: [
    {
      img: InstaOne,
    },
    {
      img: InstaTwo,
    },
    {
      img: InstaThree,
    },
    {
      img: InstaFour,
    },
    {
      img: InstaFive,
    },
    {
      img: InstaSix,
    },
    {
      img: InstaSeven,
    },
    {
      img: InstaEight,
    },
    {
      img: InstaNine,
    },
  ],
  instagramFeedTwo: [
    {
      img: InstaTen,
    },
    {
      img: InstaEleven,
    },
    {
      img: InstaTwelve,
    },
    {
      img: InstaThirteen,
    },
    {
      img: InstaFourteen,
    },
    {
      img: InstaFifteen,
    },
    {
      img: InstaSixteen,
    },
    {
      img: InstaSeventeen,
    },
  ],
  newsChannels: [
    {
      img: AbcNews,
    },
    {
      img: NbpNews,
    },
    {
      img: DigitalJournalNews,
    },
    {
      img: FoxNews,
    },
    {
      img: MarketWatchNews,
    },
    {
      img: UseTodayNews,
    },
  ],
  inpersonTab: "inperson",
  onlineTab: "online",
  virtualTab: "virtual",
  workoutDetails: [
    {
      workoutImage: InPersonBlockImg,
      monthlyPrice: "$340/mo",
      yearlyPrice: "$3672/yr",
      workoutName: "In-person workouts",
      tab: "inperson",
    },
    {
      workoutImage: VirtualBlockImg,
      monthlyPrice: "$300/mo",
      yearlyPrice: "$3240/yr",
      workoutName: "Virtual workouts",
      tab: "virtual",
    },
    {
      workoutImage: OnlineBlockImg,
      monthlyPrice: "$50/mo",
      yearlyPrice: "$479.4/yr",
      workoutName: "Online workouts",
      tab: "online",
    },
  ],
  overviewSliderContent: [
    <img src={SlideImgOne} alt="1" />,
    <img src={SlideImgTwo} alt="2" />,
    <img src={SlideImgThree} alt="3" />,
    <img src={SlideImgFour} alt="4" />,
    <img src={SlideImgFive} alt="5" />,
    <img src={SlideImgSix} alt="6" />,
  ],
  companyInfo: [
    {
      id: 1,
      title: "Mission",
      Description:
        "As the leader of in-home fitness, Omni-Active® Fitness is committed to providing individuals of all fitness levels with convenient, customized, and creative workouts in their home or other suitable location.",
    },
    {
      id: 2,
      title: "Our Vision",
      Description:
        "Our on-site fitness concept will allow men and women of any age and fitness level to achieve their health and fitness goals wherever it is most convenient. Omni-Active® Fitness is a premier organization that expects the most out of our highly qualified personal trainers but in return, allows them to have a stable and advancing career in the industry they love.",
    },
    {
      id: 3,
      title: "Growth Aspirations",
      Description:
        "Our ultimate growth goal is to build a business that changes the personal training industry for the greater good of the client and trainer. Giving clients the option to choose when and where they workout teaches them that exercise is a must no matter the time or space they have available. Secondly, we want to encourage the health and fitness minded individual who dreams of becoming a personal trainer and changing lives of those around them. Through higher wages, a strong team atmosphere, and solid company standards, we will find and work with the industry’s best.",
    },
  ],
  workoutSliderContent: [
    {
      img: SlideImgOne,
      title: "Workout anywhere,",
      subTitle: "anytime",
    },
    {
      img: SlideImgTwo,
      title: "Get omni-coins for",
      subTitle: "completing workouts",
    },
    {
      img: SlideImgThree,
      title: "Workout using plans",
      subTitle: "created for you",
    },
    {
      img: SlideImgFour,
      title: "Train in-person with",
      subTitle: "a trainer",
    },
    {
      img: SlideImgFive,
      title: "Workout virtually",
      subTitle: "with the Trainer",
    },
    {
      img: SlideImgSix,
      title: "Stay in touch with",
      subTitle: "your trainer",
    },
  ],
  overviewSliderContent: [
    <img className="slider-img" src={SlideImgOne} alt="1" />,
    <img className="slider-img" src={SlideImgTwo} alt="2" />,
    <img className="slider-img" src={SlideImgThree} alt="3" />,
    <img className="slider-img" src={SlideImgFour} alt="4" />,
    <img className="slider-img" src={SlideImgFive} alt="5" />,
  ],
  TABS: Object.freeze({
    IN_PERSON: "inperson",
    ONLINE: "online",
    VIRTUAL: "virtual",
    CORPORATE_WELLNESS: "corporate_wellness",
  }),
};

export default CONSTANTS;
